<template>
  <svg class="icon">
    <use :xlink:href="`#icon${iconName}`" />
  </svg>
</template>

<script >
export default {
  props: ['iconName']
};
</script>

<style lang="less">
.icon {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
}
</style>
